import { render, staticRenderFns } from "./SelectStamp.vue?vue&type=template&id=1269cc9a&scoped=true"
import script from "./SelectStamp.vue?vue&type=script&lang=js"
export * from "./SelectStamp.vue?vue&type=script&lang=js"
import style0 from "./SelectStamp.vue?vue&type=style&index=0&id=1269cc9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1269cc9a",
  null
  
)

export default component.exports